var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTokenInvalid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2965",
    "data-name": "Group 2965",
    transform: "translate(-627 -285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_130",
    "data-name": "Ellipse 130",
    transform: "translate(627 285)",
    fill: "#fff",
    stroke: "#004f71",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 57,
    r: 57,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 57,
    r: 56,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cancel-svgrepo-com-2",
    transform: "translate(656.335 305.202)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2969",
    "data-name": "Group 2969",
    transform: "translate(0 10.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2968",
    "data-name": "Group 2968",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41131",
    "data-name": "Path 41131",
    d: "M1.221,10.24A1.15,1.15,0,0,0,0,11.272v6.714H2.213V12.453H7.746V10.24Z",
    transform: "translate(0 -10.24)",
    fill: "#004f71",
    stroke: "#004f71",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2971",
    "data-name": "Group 2971",
    transform: "translate(47.584 10.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2970",
    "data-name": "Group 2970",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41132",
    "data-name": "Path 41132",
    d: "M447.074,10.24H440.32v2.213h5.533v5.533h2.213V11.272A.952.952,0,0,0,447.074,10.24Z",
    transform: "translate(-440.32 -10.24)",
    fill: "#004f71",
    stroke: "#004f71",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2973",
    "data-name": "Group 2973",
    transform: "translate(0 55.611)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2972",
    "data-name": "Group 2972"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41133",
    "data-name": "Path 41133",
    d: "M2.213,435.613V430.08H0v6.565a1.275,1.275,0,0,0,1.221,1.181H7.746v-2.213H2.213Z",
    transform: "translate(0 -430.08)",
    fill: "#004f71",
    stroke: "#004f71",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2975",
    "data-name": "Group 2975",
    transform: "translate(47.584 55.611)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2974",
    "data-name": "Group 2974"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41134",
    "data-name": "Path 41134",
    d: "M445.853,430.08v5.533H440.32v2.213h6.754a1.082,1.082,0,0,0,.992-1.181V430.08Z",
    transform: "translate(-440.32 -430.08)",
    fill: "#004f71",
    stroke: "#004f71",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2977",
    "data-name": "Group 2977",
    transform: "translate(21.025 61.144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2976",
    "data-name": "Group 2976",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6065",
    "data-name": "Rectangle 6065",
    width: 13.279,
    height: 2.213,
    fill: "#004f71",
    stroke: "#004f71",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2979",
    "data-name": "Group 2979",
    transform: "translate(53.117 30.159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2978",
    "data-name": "Group 2978"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6066",
    "data-name": "Rectangle 6066",
    width: 2.213,
    height: 13.279,
    fill: "#004f71",
    stroke: "#004f71",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2981",
    "data-name": "Group 2981",
    transform: "translate(0 30.159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2980",
    "data-name": "Group 2980"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6067",
    "data-name": "Rectangle 6067",
    width: 2.213,
    height: 13.279,
    fill: "#004f71",
    stroke: "#004f71",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2983",
    "data-name": "Group 2983",
    transform: "translate(21.025 10.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2982",
    "data-name": "Group 2982",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6068",
    "data-name": "Rectangle 6068",
    width: 13.279,
    height: 2.213,
    fill: "#004f71",
    stroke: "#004f71",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2985",
    "data-name": "Group 2985",
    transform: "translate(16.255 25.199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2984",
    "data-name": "Group 2984",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41135",
    "data-name": "Path 41135",
    d: "M174.575,150.232l-1.565-1.565L162.5,159.18l-10.513-10.513-1.565,1.565,10.513,10.513L150.42,171.257l1.565,1.565L162.5,162.309l10.513,10.513,1.565-1.565-10.513-10.513Z",
    transform: "translate(-150.42 -148.667)",
    fill: "#004f71",
    stroke: "#004f71",
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenInvalid);
export default __webpack_public_path__ + "static/media/token-invalid.3e55e376.svg";
export { ForwardRef as ReactComponent };